module.exports = __webpack_public_path__ + "img/project-1.20542362.png";